import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const DownArrowIcon: React.FC<ISvgIcons> = ({
    className = "",
    ...rest
}) => (
    <svg
        viewBox="0 0 25 25"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" />
    </svg>
)
